import React from 'react';
import { motion } from 'framer-motion';
export function UrgencySection() {
  return <section className="py-20 md:py-28 bg-[#111111] text-[#FAF7F2] relative overflow-hidden" data-id="element-268">
      {/* Subtle red glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-[#B91C1C]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-269"></div>

      <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-270">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-271">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-[#B91C1C]" data-id="element-272">
            🚨 ¿POR QUÉ ES URGENTE?
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-273">
          <motion.p className="text-xl md:text-2xl text-[#FAF7F2]/90 font-light leading-relaxed" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-274">
            Cada mes sin intimidad real es un mes más de distancia emocional.
          </motion.p>

          <motion.p className="text-xl md:text-2xl text-[#FAF7F2]/90 font-light leading-relaxed" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-275">
            Cada año en automático es más difícil de revertir.
          </motion.p>

          <div className="w-full h-px bg-[#C5A55A]/20 my-4" data-id="element-276"></div>

          <motion.p className="text-xl md:text-2xl text-[#FAF7F2] font-medium" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-277">
            No esperes a que el dolor te obligue.
          </motion.p>

          <motion.p className="text-2xl md:text-3xl font-bold font-serif text-[#C5A55A]" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-278">
            Actúa mientras aún hay amor.
          </motion.p>
        </div>
      </div>
    </section>;
}